import { i18n } from "../../../internationalize/i18n.service"
import { dateLocaleString } from "../../../auth/helpers"
import { type Hit } from '../../models/hit'

export class SearchHitComponent extends HTMLElement {
  private shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  set hit(hit: Hit) {
    this.render(hit)
  }

  render(hit: any) {
    const dateHTML = (date: number) =>
      `
      <div class="hit-item-date">
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 0.999878V2.49988" stroke="var(--midnight-blue)" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.5 0.999878V2.49988" stroke="var(--midnight-blue)" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.25 4.54492H10.75" stroke="var(--midnight-blue)" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 4.24988V8.49988C11 9.99988 10.25 10.9999 8.5 10.9999H4.5C2.75 10.9999 2 9.99988 2 8.49988V4.24988C2 2.74988 2.75 1.74988 4.5 1.74988H8.5C10.25 1.74988 11 2.74988 11 4.24988Z" stroke="var(--midnight-blue)" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="caption1">${dateLocaleString(date)}</div>
      </div>
    `
    const date = hit.createdOn

    this.shadow.innerHTML = `
<li class="hit-item">
        <div class="hit-item-content">
          <div class="hit-item-thumbnail">
            <img src=${hit.thumbnail.url}>
          </div>
          <a class="hit-item-link body3" href=/${hit.url}>${hit.name}</a>
        </div>
        ${date ? dateHTML(date) : ""}
        <a class="hit-item-see caption1" href=/${hit.url}>${i18n.t("see")}</a>
      </li>
    `
  }
}